import store from 'redux-store/store';

import { serviceSettings } from './constants/serviceSettings';

import type { IAppSettings } from 'redux-store/settings/settings.store';

export const getServiceSettings = () => {
  const { appSettings } = store.getState().settings;

  return {
    ...serviceSettings,
    settings: appSettings as IAppSettings,
  };
};
